export let TYPE_H5P=1
export let TYPE_DOCUMENT=2
export let TYPE_TEST=3
export let FILE_YOUTUBE=4
export let FILE_CANVA=5
export let FILE_LINK=6
export let REFERENCE_LECTURE=7

export let TYPE_FILE_PDF=8
export let TYPE_FILE_POWERPOINT=9
export let TYPE_FILE_WORD=10
export let TYPE_FILE_EXCEL=11
export let TYPE_FILE_IMAGE=12



export let PLANING_LESSON_WAREHOUSE=4
export let PLANING_LESSON_ASSIGN=3
export let ELECTRONIC_LECTURE_ASSIGN = 1
export let ELECTRONIC_LECTURE_WAREHOUSE = 2